<template>
  <div class="container">
    <Header ref="header" class="header" data-title="렌탈" type="empty"></Header>
    <!-- content(s) -->
    <div id="content" style="padding-bottom: 72px;">
      <section class="new_h">
        <div class="resultMsg hko onlyMsg">
          <p class="copy">주문이 완료 되었습니다.</p>
          <ul v-if="coupon" class="couponList mt20">
            <li>
              <a class="block bgColor0">
                <div class="inner">
                  <strong class="copy medium">{{ coupon }}</strong>
                  <span class="desc">렌탈전용 웰몰쿠폰</span>
                </div>
              </a>
            </li>
          </ul>

          <p v-if="coupon" class="desc">최대 할인 혜택이 적용 되었어요.</p>
        </div>

        <section>
          <div class="banner">
            <ul class="slideList">
              <li>
                <a @click="$router.push('/event/dailyEvent')">
                  <img src="https://www.welrixrental.co.kr/img_1/welmall_comm_img/1598485812217_temp_banner_ev01.png" alt="" />
                </a>
              </li>
            </ul>
          </div>
        </section>

        <div class="btnArea sticky">
          <button type="button" class="btn_p" @click="$router.push('/')">
            확인
          </button>
        </div>
      </section>
    </div>
    <!-- content(e) -->
  </div>
</template>

<script>
import JwtService from '@/common/jwt.service';
export default {
  name: 'MemberRentalEnd',
  data() {
    return {
      coupon: this.$route.params.couponTitle,
      agreeAppPush: this.$route.params.agreeAppPush,
    };
  },
  mounted() {
    let userId = '';
    if (JwtService.getToken()) {
      userId = JwtService.getUserInfo().userId;
    }
    this.$refs.header.pushUpdate(this.agreeAppPush, userId);
  },
};
</script>

<style scoped>
.couponList {
  padding: 0;
  margin: 0 auto;
  width: 260px;
}
.couponList .block {
  padding: 30px 45px 30px 0;
}
.couponList .block .copy {
  font-size: 2rem;
}
</style>
